<template>
  <td class="app-menu-conectados" :class="'app-menu-conectados--' + cpntTipo">
    <!-- SETA O NUMERO D USUARIOS CONECTADOS -->
    <div class="numeros" ref="divBotao" @click="appMenuConectadosMostrarDados">
      <span v-html="cpntNumero"></span>
    </div>

    <!-- SETA O CONTEUDO DA TELA -->
    <RF-Dialog-Referencia :cpntPositionFixed="true" v-if="mostrar === true" :cpntElement="$refs.divBotao" :cpntOnFechar="appMenuConectadosMostrarDados" :cpntAlignX="'auto-end'">
      <div class="app-menu-conectados-dados" :style="'width: ' + ($store.state.tamanhoTela.width - 26 - 2)">
        <!-- SETA O STATUS DA REQUISIÇÃO -->
        <RF-Status v-if="statusGeral !== ''" :cpntStatus='statusGeral' :cpntTamanho='5'></RF-Status>

        <!-- APRESENTA A TABELA -->
        <template v-else-if="statusGeral === ''">
          <!-- APRESENTA O TITULO DA PAGINA -->
          <div class="titulo">
            <!-- SETA O ICONE -->
            <svg aria-hidden="true" class="fa fa-angle-double-right"></svg>

            <!-- SETA O TITULO -->
            <span v-if="cpntTipo === 'demonstrativo'">Contrato Demonstrativo</span>
            <span v-else-if="cpntTipo === 'licenca'">Contrato Licença de uso</span>
          </div>

          <!-- APRESENTA A TABELA -->
          <div style="max-height: calc(100vh - 100px); overflow: auto; padding-right: 10px; width: calc(100% + 10px); margin-top: -10px; padding-top: 10px;">
            <RF-Tabela v-if="Object.keys(tabela).length >= 1" style=""
              :data-time='time'
              :cpntTime='time'
              :cpntId='tabela.id'
              :cpntStatus='tabela.status'
              :cpntButtonImprimir='tabela.acoes.btImprimir'
              :cpntButtonImprimirOculta='tabela.acoes.btImprimirOculta'
              :cpntButtonAtualizar='tabela.acoes.btAtualizar'
              :cpntFraseTop='tabela.fraseTop'
              :cpntInfoTabela='tabela.infoTabela'
              :cpntColuna='tabela.coluna'
              :cpntLinha='tabela.linha'
              :cpntCountAll='tabela.countAll'
              :cpntColspan='tabela.colspan'
              :cpntColQtip='tabela.colqtip'
              :cpntButtonsAcoes='tabela.acoes.buttons'
              :cpntMper='tabela.mper'
              :cpntPagina='tabela.pagina'
              :cpntCheckboxEditar='tabela.checkboxEditar'
              :cpntFieldsEditar='tabela.acoes.fields'
              :ref='tabela.id'
            ></RF-Tabela>
          </div>
        </template>
      </div>
    </RF-Dialog-Referencia>
  </td>
</template>

<style scoped>
  .app-menu-conectados {
    padding: 5px 3px;
    user-select: text;
  }
  .app-menu-conectados > .numeros {
    width: 27px;
    min-width: 27px;
    height: 27px;
    padding: 0px 4px;
    border-radius: 4px;
    text-align: center;
    font-size: 13px;
    line-height: 22px;
    cursor: pointer;
  }
  .app-menu-conectados-dados {
    max-width: 450px;
  }
  .app-menu-conectados-dados > .titulo {
    width: calc(100% + 10px);
    margin-top: -5px;
    margin-left: -5px;
    margin-bottom: 10px;
    background: #e9e9e9;
    padding: 5px 10px 5px 10px;
    color: #444;
    font-weight: bold;
    border-bottom: 1px solid #ccc;
  }
    .app-menu-conectados-dados > .titulo > svg {
      margin-right: 5px;
    }
</style>

<style>
.app-menu-conectados--demonstrativo > .numeros,
.app-menu-conectados--demonstrativo > .app-menu-dialog > .dialog-conteudo {
  border: 2px solid #eea236 !important;
  color: #fff !important;
}
.app-menu-conectados--licenca > .numeros,
.app-menu-conectados--licenca > .app-menu-dialog > .dialog-conteudo {
  border: 2px solid #4cae4c !important;
  color: #fff !important;
}
.app-menu-conectados-dados > div > div > table > tbody > tr > td.col-cliente {
  text-align: left;
  white-space: pre-wrap !important;
}
</style>

<script>
  export default {
    props: {
      cpntTipo: {
        required: true,
        type: String
      },
      cpntNumero: {
        required: true,
        type: Number
      }
    },
    components: {
      'RF-Dialog-Referencia': () => import('@/components/rf-geral/dialog/RF-Dialog-Referencia.vue')
    },
    data: function () {
      return {
        time: '',
        statusGeral: 'carregando',
        mostrar: false,
        tabela: {}
      }
    },
    destroyed: function () {
      this.$store.state.WEB_SOCKET_OBSERVADOR('UsuOnline', 'app-menu-usu-online-lista', null)
    },
    mounted: function () {
      this.$store.state.WEB_SOCKET_OBSERVADOR('UsuOnline', 'app-menu-usu-online-lista', () => {
        if (Object.keys(this.tabela).length >= 1) {
          this.appMenuConectadosBuscarDados()
        }
      }, 'usu')
    },
    methods: {
      appMenuConectadosSetarStatusGeral: function (status) {
        // SETA O STATUS DA TELA
        this.statusGeral = status

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      appMenuConectadosMostrarDados: function (event) {
        if (event.type === 'click') {
          // SETA SE DEVE OU NÃO MOSTRAR O REGISTRO
          this.mostrar = !this.mostrar

          // VERIFICA SE DEVE BUSCAR OS DADOS
          if (this.mostrar === true) {
            this.appMenuConectadosMontarTabela()
          }
        }
      },
      appMenuConectadosBuscarDados: function (callback = null) {
        // SETA O QUERY GET QUE DEVE SER REALIZADO
        var queryGet = 'lista'

        // CHAMA FUNÇÃO PARA COMUNICAR COM API
        this.$store.state.comunicaAPI('/subase/painel/usu-online/get/', 'GET', queryGet, (apiSuccess) => {
          // LIMPA OS DADOS DO VETOR
          var linha = []

          // INICIA A VARIAVEL
          var mostrarEmail = 0

          // VERIFICA O REGISTRO QUE DEVE PEGAR
          switch (this.cpntTipo) {
            case 'demonstrativo':
              linha = apiSuccess.data.d

              // SETA QUE DEVE MOSTRAR O EMAIL
              mostrarEmail = 1
              break

            case 'licenca':
              // ADICIONA AS LINHAS
              linha = apiSuccess.data.l

              // SETA QUE DEVE OCULTAR O EMAIL
              mostrarEmail = 0
              break
          }

          // PEGA A POSIÇÃO DA CHAVE EMAIL
          var indexC = this.tabela.coluna.findIndex(item => item.chave === 'email')

          // SETA O VALOR SE DEVE OU NÃO MOSTRAR A COLUNA
          this.tabela.coluna[indexC].mPer = mostrarEmail

          for (var index in linha) {
            //pega apenas as palavras e tira todos os espaços em branco.
            linha[index].cliente = linha[index].cliente.replace(/\w\S*/g, (str) => {
              //passa o primeiro caractere para maiusculo, e adiciona o todo resto minusculo
              return str.charAt(0).toUpperCase() + str.substr(1).toLowerCase()
            })
            
            // VERIFICA SE TEM E-MAIL PARA QUEBRAR
            if ([ '', null, undefined ].indexOf(linha[index].email) === -1) {
              linha[index].email = linha[index].email.split(';').join('<br/>')
            }
          }

          // SETA AS LINHA RECEBIDAS
          this.tabela.linha = linha

          // SETA A ATUALIZAÇÃO DOS NUMEROS
          this.$emit('UPDATE_NUMERO', this.cpntTipo, linha.length)

          // CHAMA A FUNÇÃO CALLBACK
          if (callback !== null && typeof callback === 'function') {
            callback()
          }
        }, this.appMenuConectadosSetarStatusGeral)
      },
      appMenuConectadosMontarTabela: function () {
        // SETA O STATUS DA PAGINA
        this.appMenuConectadosSetarStatusGeral('carregando')

        // LIMPA OS CAMPOS PARA SEREM INICIANDO NOVAMENTE
        var tabela = {
          status: '',
          id: 'app-menu-conectado',
          linha: [],
          coluna: [
            { mPer: 2, chave: 'clu', nome: 'CLU' },
            { mPer: 1, chave: 'cliente', nome: 'Razão Social' },
            { mPer: 1, chave: 'usuario', nome: 'Usuário' },
            { mPer: 1, chave: 'email', nome: 'E-mail' }
          ],
          montarTabelaCompleta: false
        }

        // FAZ A MONTAGEM DAS INFORMAÇÕES PARA TABELA
        this.$store.state.FUN_TABELA_CRIAR_DADOS(tabela, (event) => {
          // ATUALIZA A TABELA SOLICITADA
          this.tabela = event

          // CHAMA A FUNÇÃO PARA BUSCAR AS LINHAS
          this.appMenuConectadosBuscarDados(() => { this.appMenuConectadosSetarStatusGeral('') })
        }, this.appMenuConectadosSetarStatusGeral)
      }
    }
  }
</script>
